<div class="d-flex flex-column justify-content-center mx-5 my-5">
    <H1 class="text-center"><i class="fas fa-ban"></i> No Results Found.</H1>
    <div class="text-center"><p>Your search returned no results.  Please edit your search using the button below.</p></div>
    <div class="flex-fill">
        <app-results-search-info [queryString]="queryString" [routeLink]="routeLink"></app-results-search-info>
    </div>
    <!-- <button type="submit" class="btn btn-lg btn-primary mt-3" (click)="goSearch();"><i class="fas fa-search"></i>
        Edit Search</button> -->
</div>